import { styled } from '@/stitches.config';
import { Box, SectionTitle } from '@base-app';

export const StyledCollectionAndSequencingContainer = styled(Box, {
  display: 'flex',
  gap: '$6',
  justifyContent: 'flex-start',
});

export const StyledLeftContainer = styled(Box, {
  width: '100%',
});

export const StyledRightContainer = styled(Box, {
  alignItems: 'flex-end',
  display: 'flex',
  flexDirection: 'column',
  gap: '$6',
  justifyContent: 'space-between',
  maxWidth: '465px',
  width: '70%',
});

export const StyledSubPageHeaderContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '$7 0',
  width: '100%',
  variants: {
    isSticky: {
      true: {
        alignItems: 'center',
        backgroundColor: '$white',
        borderBottom: '$borderWidths$1 solid $grey200',
        boxShadow: '$stickyNav',
        display: 'flex',
        height: '$stickyNav$height',
        justifyContent: 'space-evenly',
        left: '0',
        margin: '0',
        overflow: 'visible',
        paddingLeft: '$studyInsights$sidebarWidthClose',
        position: 'fixed',
        transition: 'top 400ms ease-in-out 0s',
        width: '100%',
        zIndex: '$stickyHeader',
      },
    },
  },
});

export const StyledSelectedRange = styled(Box, {
  alignItems: 'center',
  color: '$darkBlue200',
  display: 'flex',
  fontSize: '$4',
  fontWeight: '$regular',
  lineHeight: '$6',
});

export const StyledDate = styled(Box, {
  marginLeft: '$4',
  fontWeight: '$bold',
  lineHeight: '$6',
});

export const StyleDateContainer = styled(Box, {
  display: 'flex',
  alignItems: 'center',
});

export const StyledSelectContainer = styled(Box, {
  marginLeft: '$4',
});

export const StyledEditGoalTitle = styled(SectionTitle, {
  color: '$darkBlue100',
  fontSize: '$xl',
  fontWeight: '$bold',
  lineHeight: '$6',
});
